import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';
import type {
  ApiResponse,
  PasswordUpdateData,
  UserProfileData,
} from '../types/profile-management.types';

export const updateProfile = async (userData: UserProfileData): Promise<ApiResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.updateProfileByUser}`;
  return await request.put(url, userData);
};

export const updateProfilePassword = async (
  passwordData: PasswordUpdateData
): Promise<ApiResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.updateProfilePassword}`;
  return await request.put(url, passwordData);
};
